module.exports = __webpack_public_path__ + "static/img/14000361.f53b79d2.png";